// extracted by mini-css-extract-plugin
module.exports = {"eP60Table":"Ep60ListTab_eP60Table__S5F_N"};